import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'
import localCache from "@/utils/cache";
import LoaddingApi from '@/utils/loadding';
import { ElMessage } from 'element-plus'
import { useRouter } from 'vue-router'
//router实例
const router = useRouter();

//创建实例
const request: AxiosInstance = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL + '/api',
    timeout: Number(process.env.VUE_APP_TIME_OUT)
});

const loadding = new LoaddingApi('.msi-content')
/**
 * @desc: 异常拦截处理器
 * @param { Object } error 错误信息
 */
const errorHandler = (error: AxiosError): AxiosError | Promise<AxiosError> => {
    // ElMessage.error(JSON.stringify(error))
    //关闭loading
    // loading.close();
    //返回错误

    loadding.close()
    return Promise.reject(error)
}

/**
 * @desc: 请求发送前拦截
 * @param { Object } config 配置参数
 */
request.interceptors.request.use((config: AxiosRequestConfig): AxiosRequestConfig => {
    loadding.create()
    //获取token
    const token: string = localCache.getCache("token") || '';
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, errorHandler)

/**
 * @desc: 服务端响应后拦截
 * @param { Object } response 返回的数据
 */
request.interceptors.response.use((response: AxiosResponse): AxiosResponse | Promise<AxiosResponse> => {
    console.log(loadding,'loadding')
    loadding.close()
    const { data } = response;
    const res = data;
    //请求成功
    if (res.code == 200 || res.code === 204) {
        
        return Promise.resolve(res);
    } else if (res.code == 401) { //登录超时
       
        //清除token
        localCache.deleteCache('token');
        ElMessage.error(`${res.code}:${JSON.stringify(res.message)}`)
        router.push({ path: '/login', query: { redirect: router.currentRoute.value.fullPath } });
        return Promise.reject(res);
    } else {
        //访问接口失败
        ElMessage.error(`${res.code}:${JSON.stringify(res.message)}`)
        return Promise.reject(res);
    }
}, errorHandler)

export default request